export const PromotionTypes = {
  0: _TL_('Special offer'),
  1: _TL_('Weekly deals'),
  2: _TL_('Halloween'),
  3: _TL_('Black Friday'),
  4: _TL_('Christmas'),
  5: _TL_('New Year'),
};

export const EnhancedPromotionTypes = {
  Money_Off: _TL_('Amount off'),
  Percent_Off: _TL_('Percent off'),
  Free_Gift: _TL_('Free gift'),
  Free_Gift_With_Value: _TL_('Free gift'),
  Free_Shipping_Standard: _TL_('Free shipping'),
  Free_Shipping_Overnight: _TL_('Free shipping'),
  Free_Shipping_Two_Day: _TL_('Free shipping'),
};
